import type { ModuleName } from '../modules';
import type { LotteryFormTemplate } from '../types';

export const filterTemplate = (
  modules: Array<ModuleName>,
  template: LotteryFormTemplate
): LotteryFormTemplate => {
  const filteredTemplate: LotteryFormTemplate = {} as LotteryFormTemplate;
  (Object.keys(template) as Array<keyof typeof template>).forEach((key) => {
    filteredTemplate[key] = template[key].filter((module) => modules.includes(module));
  });
  return filteredTemplate;
};
